import { MessageReceived, MessageSendAction, MessageSent } from "../../models/webSockets";
import { AbstractSocketService } from "./abstractSocketService";

class MockSocketService extends AbstractSocketService {

  constructor() {
    super();

    this.messageListeners = [];
  }

  public static getInstance(): AbstractSocketService {
    if (!AbstractSocketService.instance) {
      AbstractSocketService.instance = new MockSocketService();
    }

    return AbstractSocketService.instance;
  }

  public sendMessage () {
    return;
  }

  public async broadcastMessage<T>(payload: MessageReceived<T>, excludeSender = true) {
    if (excludeSender) {
      return;
    }

    const message: MessageSent<T> = {
      action: MessageSendAction.BROADCAST,
      payload,
      excludeSender,
    };

    this.handleMessage(JSON.stringify(message.payload));
  }

}

export default MockSocketService;
